<template>
  <div class="bids-list container">
    <section
      v-if="responses.length"
      v-loading="loadedResponses"
      class="middle-section"
    >
      <el-row :gutter="24" style="text-align: center; margin: 15px 0 10px">
        <el-col :span="1">
          <el-checkbox
            v-model="checkAll"
            :indeterminate="isIndeterminate"
            @change="handleCheckAllChange"
          />
        </el-col>
        <el-col :span="3">Дата</el-col>
        <el-col :span="3">Авто/прицеп</el-col>
        <el-col :span="5">Перевозчик</el-col>
        <el-col :span="3">Цена</el-col>
        <el-col :span="4">
          <div class="switch--contracts-vs-value">
            <span
              class="contracts"
              :class="{ active: !switchContracts }"
              @click="handleSwitchContracts('contracts')"
            >
              Акты и ТТН
            </span>
            /
            <span
              class="value"
              :class="{ active: switchContracts }"
              @click="handleSwitchContracts('value')"
            >
              Значения
            </span>
          </div>
        </el-col>
        <el-col :span="3">Оплаты</el-col>
        <el-col :span="2">Удалить из отчета</el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-checkbox-group
            v-model="checked_request"
            @change="handleCheckedChange"
          >
            <div
              v-for="response in responses"
              :key="response.id"
              :ref="'response' + response.id"
              class="check-list report-response-item"
            >
              {{ response }}
              <el-col class="auto-list_col" :span="1">
                <div class="check-list-time auto-list_col_centered">
                  <el-checkbox :label="response" :value="response" />
                </div>
              </el-col>
              <div @click="callModal(response)">
                <el-col class="auto-list_col" :span="3">
                  <column-date :response="response" :set-open="setOpen" />
                </el-col>

                <el-col class="auto-list_col" :span="3">
                  <column-state-numbers :response-auto="response.auto" />
                </el-col>

                <el-col class="auto-list_col" :span="5">
                  <column-driver
                    :driver="response.driver"
                    :organization="response.organization"
                  />
                </el-col>

                <el-col class="auto-list_col" :span="3">
                  <column-price :response="response" :type="bid.type_code" />
                </el-col>

                <el-col v-loading="!response" class="auto-list_col" :span="4">
                  <div v-if="switchContracts" class="check-list-phone">
                    <column-act
                      :response="response"
                      :on-act-click="onActClick"
                    />
                    <column-ttns
                      :response="response"
                      :on-t-t-n-click="onTTNClick"
                    />
                  </div>
                  <div v-else>
                    <column-act-ttns-value
                      :response="response"
                      :on-act-click="onActClick"
                      :on-t-t-n-click="onTTNClick"
                    />
                  </div>
                </el-col>

                <el-col class="auto-list_col" :span="3">
                  <column-payment
                    :id="response.id"
                    :left="response.payment_left"
                    :response="response"
                    :on-payment-click="onPaymentClick"
                  />
                </el-col>
              </div>

              <el-col
                v-if="canAction('deleteResponse')"
                class="auto-list_col"
                :span="2"
              >
                <column-delete
                  :response="response"
                  :on-delete-response-click="onDeleteResponseClick"
                />
              </el-col>
            </div>
          </el-checkbox-group>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <div class="pagination">
            <pagination-custom :data="pagination" @changed="changePage" />
          </div>
        </el-col>
      </el-row>
    </section>

    <el-dialog
      class="passport_dialog_window"
      width="auto"
      :visible.sync="passportDialog"
      append-to-body
    >
      <passport-fill
        v-if="passportDialog"
        :current-person="currentPerson"
        :type="bid.type_code"
        @saved="$emit('changed')"
      />
    </el-dialog>

    <modal-ttn
      v-if="currentDay"
      :response="TTNMode"
      :shortage="shortage"
      :load-date="currentDay.load_date"
      :type="bid.type_code"
      @close="TTNMode = null"
      @update="fetchData"
    />

    <bids-payments-modal
      v-if="paymentDialog"
      :loading="paymentLoading"
      :paying-loader="payingLoader"
      :payment-dialog="paymentDialog"
      :response="activeResponse || {}"
      :active-act="activeAct"
      :bid="bid"
      @close="paymentDialog = false"
      @update="fetchData"
      @status="fetchData"
    />

    <bids-act-modal
      :act-dialog="actDialog"
      :response="activeActResponse || {}"
      :active-act="activeAct || {}"
      :doc-types="docTypes"
      :loader="loader"
      @close="
        actDialog = false
        activeAct = null
      "
      @update="fetchData"
      @set="updatePerformer"
    />

    <resp-status-modal
      v-if="statusDialog && activeResponse.id"
      :visible="statusDialog"
      :response="getActiveResponse()"
      :day="currentDay.load_date"
      @close="onClose"
      @update="fetchStore"
    />
    <delete-response-modal
      v-if="deleteDialog"
      :response="activeResponse"
      :visible="deleteDialog"
      :report-id="report.id"
      @update="updateResponsesAfterDelete"
      @close="deleteDialog = false"
    />
    <fixed-block
      :checked-responses="checked_request"
      :responses="responses"
      :type="bid.type_code"
    />
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapGetters, mapMutations } from 'vuex'

import { statuses } from '@/datas/responseStatuses'

import BidsActModal from '@/views/LoadDay/Modals/Act/BidsActModal'
import BidsPaymentsModal from '@/views/LoadDay/Modals/Payments/BidsPaymentsModal'
import DeleteResponseModal from '@/views/Report/Modals/Delete'
import ModalTtn from '@/components/Modals/ModalTTN'
import PassportFill from '@/components/Forms/PassportFill'
import RespStatusModal from '@/views/LoadDay/Modals/RespStatusModal'

import { FETCH_RESPONSES, REMOVE_REPORT } from '@/store/actions/reports'
import ColumnAct from '@/views/Report/Components/Responses/Columns/Act'
import ColumnActTtnsValue from '@/views/Report/Components/Responses/Columns/ActTtnsValue'
import ColumnDate from '@/views/LoadDay/Components/Responses/Columns/Date'
import ColumnDelete from '@/views/Report/Components/Responses/Columns/Delete'
import ColumnDriver from '@/views/Report/Components/Responses/Columns/Driver'
import ColumnPayment from '@/views/Report/Components/Responses/Columns/Payment'
import ColumnPrice from '@/views/Report/Components/Responses/Columns/Price'
import ColumnStateNumbers from '@/views/Report/Components/Responses/Columns/StateNumbers'
import ColumnTtns from '@/views/Report/Components/Responses/Columns/Ttns'
import FixedBlock from '@/views/Report/Components/FixedBlock'
import PaginationCustom from '@/components/Tables/PaginationCustom'

const DocApi = RepositoryFactory.get('document')

export default {
  name: 'ResponseList',
  components: {
    ColumnDate,
    ColumnDriver,
    ColumnStateNumbers,
    ColumnPrice,
    ColumnDelete,
    ColumnAct,
    ColumnTtns,
    ColumnPayment,
    ColumnActTtnsValue,
    PassportFill,
    ModalTtn,
    BidsPaymentsModal,
    BidsActModal,
    RespStatusModal,
    DeleteResponseModal,
    FixedBlock,
    PaginationCustom,
  },
  props: {
    bid: {
      type: Object,
      default: () => {},
    },
    report: {
      type: Object,
      default: () => {},
    },
    pagination: {
      type: Object,
      default: () => {},
    },
    loadDays: {
      type: Array,
      default: () => [],
    },
    responses: {
      type: Array,
      default: () => [],
    },
    fetchStore: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      checkAll: false,
      isIndeterminate: false,
      checked_request: [],
      activeResponse: {},
      activeResponseStyle: null,
      curResponse: {},
      passportDialog: false,
      currentPerson: [],
      TTNMode: null,
      currentDay: {},
      activeAct: null,
      activeActResponse: {},
      actDialog: false,
      paymentDialog: false,
      loader: false,
      statusDialog: false,
      deleteDialog: false,
      switchContracts: true,
    }
  },
  computed: {
    ...mapGetters({
      docTypes: 'documentTypes/getDocumentTypes',
      paymentLoading: 'payments/getLoading',
      payingLoader: 'payments/getLoader',
      loadedResponses: 'reports/getLoadedResponses',
    }),
    shortage() {
      const res = {}

      if (this.bid) {
        const { allow_shortage_is_percents, allow_shortage } = this.bid

        res.perc = allow_shortage_is_percents
        res.val = allow_shortage || 0
      }

      return res
    },
  },
  watch: {
    activeResponseStyle(newVal, oldVal) {
      if (oldVal) {
        this.$refs['response' + oldVal][0].style.border = ''
      }
      if (newVal) {
        this.$refs['response' + newVal][0].style.border = '1px solid #3498DB'
      }
    },
  },
  methods: {
    ...mapMutations('reports', ['updateBid']),
    handleCheckAllChange(val) {
      this.checked_request = val ? this.responses : []
      this.isIndeterminate = false
    },
    handleCheckedChange(value) {
      const checkedCount = value.length

      this.checkAll = checkedCount === this.responses.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.responses.length
    },
    handleSwitchContracts(type) {
      if (
        (type === 'value' && this.switchContracts) ||
        (type === 'contracts' && !this.switchContracts)
      ) {
        this.switchContracts = !this.switchContracts
      }
    },
    getStatus(status) {
      return status >= 0 && statuses[status] ? statuses[status].name : ''
    },
    getStatusDate(res) {
      const raw = statuses[res.status]

      return raw && raw.field
        ? this.dateToFormat(res[raw.field], 'respStatusDate')
        : ''
    },
    setOpen(resp, key) {
      this.activeResponseStyle = resp.id

      if (key === 'statusDialog' && !this.canAction('editResponseStatus')) {
        return false
      }
      this.activeResponse = resp
      this[key] = true
    },
    callModal(response) {
      if (!response.auto) {
        response = { ...response, auto: {} }
      }
      this.currentPerson = response
      this.passportDialog = true
      this.activeResponseStyle = response.id
    },
    onTTNClick(response) {
      this.TTNMode = response
      this.activeResponseStyle = response.id
      this.currentDay = this.loadDays.filter(
        loadDay => loadDay.id === Number(response.load_day_id),
      )
    },
    onPaymentClick(response) {
      this.activeResponseStyle = response.id
      this.activeResponse = response
      this.fetchGetAct(response)
      this.paymentDialog = true
    },
    onDeleteResponseClick(response) {
      this.activeResponse = response
      this.activeResponseStyle = response.id
      this.deleteDialog = true
    },
    async fetchGetAct(response) {
      const documentType = this.docTypes.find(t => t.code === 'works_act')

      try {
        const { data } = await DocApi.getDocument(
          'responses',
          response.id,
          documentType.code,
        )

        this.activeAct = Array.isArray(data)
          ? data.find(c => c.files.length) || data[0]
          : null
      } catch (error) {
        console.log(error)
      } finally {
        this.loader = false
      }
    },
    async onActClick(response) {
      this.activeResponseStyle = response.id
      this.actDialog = true
      this.activeActResponse = response
      this.activeActResponse.bid = {
        org_performer_id: this.bid.org_performer_id,
      }
      this.loader = true
      this.fetchGetAct(response)
    },
    updatePerformer({ data }) {
      this.activeActResponse = {
        ...this.activeActResponse,
        bid: { org_performer_id: data.org_performer_id },
      }
      this.updateBid({ data })
    },
    getApproveStatus(response) {
      if (response['master-approve'] !== null) {
        return response['master-approve'].status
      }
    },
    onClose(key) {
      this[key] = false
      this.curResponse = null
    },
    fetchData() {
      this.fetchStore()
    },
    getActiveResponse() {
      return this.responses.filter(
        response => response.id === this.activeResponse.id,
      )[0]
    },
    updateResponsesAfterDelete(responsId) {
      this.deleteDialog = false
      this.activeResponseStyle = 0
      this.$store.dispatch(`reports/${REMOVE_REPORT}`, responsId)
    },
    changePage(page = 1) {
      this.$store.dispatch(`reports/${FETCH_RESPONSES}`, page)
      this.$router.push(`${this.$route.path}?page=${page}`)
    },
  },
}
</script>

<style lang="sass">
.bids-list .middle-section .check-list
  margin: 0 0 20px

.active-response
  background-color: gray

.bids-list
  .middle-section
    .check-list
      cursor: pointer
      margin: 0 0 20px
      background: #fff
      align-items: center
      min-height: 100px

      .auto-list_col
        min-height: 100px
        display: flex
        text-align: center
        vertical-align: middle
        flex-direction: column

        .auto-list_col_centered
          height: 100%
          display: grid
          align-items: center
          text-align: center
          margin: auto 0

      .check-list-time
        text-align: center

      .check-list-phone
        font-size: 16px
        line-height: 21px
        margin: auto 0

      .check-list-autos
        font-size: 14px
        line-height: 21px

      .check-list-action
        img
          margin: 10px

      .check-list-person
        p
          margin: 5px
          font-size: 18px
          line-height: 22px

      .grey
        color: #98A9BC
  .el-pagination
    .btn-prev,
    .number,
    .el-icon-more,
    .btn-next
      background: #F9F9F9
.mr25
  margin-right: 25px

.flex__center
  display: flex
  justify-content: center
  align-items: center
.switch--contracts-vs-value
  & .active
    color: #3498db
    cursor: pointer
    &:hover
      text-decoration: underline
</style>
